<template>
 <div>
   <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" class="demo-form-inline" label-width="100px" size="mini">
        <div class="formItemBox">
        <el-form-item label="维修日期:" class="item2">
          <el-date-picker
            v-model="searchFrom.repairDate"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
          ></el-date-picker>
        </el-form-item>
         <el-form-item label="车辆号牌:">
          <el-input placeholder="" v-model="searchFrom.plateNumber" ></el-input>
        </el-form-item>
        <el-form-item label="司机姓名:">
          <el-input placeholder="" v-model="searchFrom.driverName" ></el-input>
        </el-form-item>
        <!-- <el-form-item label="物料名称:">
          <el-select v-model="searchFrom.expenseName" filterable placeholder="请选择" >
            <el-option v-for="item in gysList" :label="item.showName" :value="item.showName" :key="item.id"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="所属小队:" >
          <el-select v-model="searchFrom.teamCode" filterable placeholder="请选择" clearable>
            <el-option v-for="item in XDList" :label="item.name" :value="item.code" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="物料单号:">
          <el-input placeholder="" v-model="searchFrom.businessNo" ></el-input>
        </el-form-item> -->
        </div>
        <div style="display: flex;align-items: center;padding-right: 20px;">
          <div class="searchBtnBox" style="flex-shrink:0">
            <el-button type="primary" size="mini" @click="searchFn" v-if="btnFlg[0]">查询</el-button>
            <el-button type="primary" size="mini" @click="resetForm('searchFrom')">重置</el-button>
            <el-button type="primary" @click="exportFn" size="mini" :disabled="isDisable" v-if="btnFlg[1]">导出</el-button>
            <el-button type="primary" @click="addFn" size="mini" v-if="btnFlg[2]">新增</el-button>
            <el-button type="primary" @click="delFn" size="mini" v-if="btnFlg[3]">删除</el-button>
            <el-button type="primary" @click="importFn" size="mini" v-if="btnFlg[6]">导入</el-button>
            <el-button type="primary" size="mini" @click="modelDown" v-if="btnFlg[7]">模板下载</el-button>
          </div>
          <div class="tongjiBox">
            <el-form-item style="margin-left:8px;margin-top: 6px;" >
              <p class="margin0" >
                工时合计：<span class="red">{{sum.totalLaborHours}}</span>小时
              </p>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList" ref="table" v-loading="loading" bordersize="mini" @selection-change="selectGoods" @row-click="handleRowClick" style="width: 100%" height="100%" center border class="tableComent">
       <el-table-column type="selection" width="55"></el-table-column>
       <el-table-column  type="index" width="55" label="序号" fixed></el-table-column>
       <el-table-column label="操作" width="130" fixed>
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="mini" @click="pingzhengFn(scope.row)" v-if="btnFlg[4]">凭证</el-button>
              <el-button type="text" size="mini" @click="editFn(scope.row)" v-if="btnFlg[5]">修改</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="businessNo" label="维修单号" min-width="190">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click.stop="detailFn(scope.row)">{{ scope.row.businessNo }}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="plateNumber" label="车头牌号" min-width="130"></el-table-column>
        <el-table-column prop="trailerPlate" label="挂车牌号" min-width="130" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="vehicleTeamName" label="车辆所属小队" min-width="130" :formatter="emptyFn"></el-table-column>
        <el-table-column prop="driverName" label="司机姓名" min-width="120"></el-table-column>
        <el-table-column prop="driverPhone" label="司机电话" min-width="120"></el-table-column>
        <el-table-column prop="teamName" label="司机所属小队" min-width="130"></el-table-column>
        <el-table-column prop="repairDate" label="维修日期" min-width="130" :formatter="dateFormat"></el-table-column>
        <el-table-column prop="maintenanceContent" label="维修项目" min-width="120"></el-table-column>
        <el-table-column prop="laborHours" label="维修工时" min-width="100"></el-table-column>
        <el-table-column prop="repairWorkers" label="维修人员" min-width="130" show-overflow-tooltip></el-table-column>
        <el-table-column prop="kilometers" label="公里数" min-width="120"></el-table-column>
        <el-table-column prop="newTireBrand" label="新胎品牌" width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="newTireModel" label="新胎型号" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="oldTireBrand" label="旧胎品牌" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="oldTireModel" label="旧胎型号" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="receiveQuantity" label="领取数量" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="oldTireDestination" label="旧胎去向" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="replacePosition" label="更换位置" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip :formatter="emptyFn"></el-table-column>
        <el-table-column prop="createUser" label="创建人" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createTime" label="创建时间" :formatter="dateTimeFormat" width="170"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,500]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 新增 -->
    <el-dialog :title="isDetail ? '详情' : (isAdd?'新增':'修改')" :close-on-click-modal="false" :close-on-press-escape="false"  @close="closeDialog" :visible.sync="addFlag" width="58%" center>
      <div>
        <el-form :inline="true" :rules="rules" ref="addForm" :model="addForm" class="demo-form-inline jiaoyan"  label-width="120px" size="mini" :disabled="isDetail" v-if="addFlag">
          <!-- <el-form-item label="司机姓名:" prop="driverId" class="width1" >
            <el-select v-model="addForm.driverId" filterable placeholder="请选择" @change="sijiChange">
              <el-option v-for="item in sijiList" :label="item.name" :value="item.id" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="司机电话:" prop="driverPhone" class="width1" >
            <el-input placeholder="" maxlength="50" v-model="addForm.driverPhone" :readonly="true"></el-input>
          </el-form-item>
          <el-form-item label="司机所属小队:" prop="teamCode" class="width1" >
            <el-select v-model="addForm.teamCode" filterable placeholder="请选择" clearable :disabled="true">
              <el-option v-for="item in XDList" :label="item.name" :value="item.code" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车头牌号:" prop="plateNumber" class="width1" >
            <el-select v-model="addForm.plateNumber" filterable placeholder="请选择" @change="carChange">
              <el-option v-for="item in carList" :label="item.vhcNo" :value="item.vhcNo" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="挂车牌号:" prop="trailerPlate" class="width1" >
            <el-input placeholder="" maxlength="50" v-model="addForm.trailerPlate" :readonly="true"></el-input>
          </el-form-item>
          <el-form-item label="车辆所属小队:" prop="vehicleTeamCode" class="width1">
            <el-select v-model="addForm.vehicleTeamCode" filterable placeholder="请选择" clearable :disabled="true">
              <el-option v-for="item in XDList" :label="item.name" :value="item.code" :key="item.id"></el-option>
            </el-select>
          </el-form-item> -->
          <driverVehicleForm :addForm = 'addForm' :XDList='XDList' :isGuaChe = 'true'></driverVehicleForm>
          <el-form-item label="维修项目:" prop="maintenanceContent">
            <el-input placeholder="" v-model="addForm.maintenanceContent"></el-input>
          </el-form-item>
          <el-form-item label="维修工时:" prop="laborHours" class="jiage" >
            <el-input placeholder="" v-number-input.float="1" maxlength="8" v-model="addForm.laborHours"  ></el-input>
            <span class="danwei" >小时</span>
          </el-form-item>
          <el-form-item label="维修人员:" prop="expenseAll" class="width1">
            <el-select v-model="addForm.expenseAll" filterable placeholder="请选择" @change="gysChange" multiple>
              <el-option v-for="item in gysList" :label="item.showName" :value="item.showName" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="公里数:" prop="kilometers" class="jiage" >
            <el-input placeholder="" v-number-input.float="3" maxlength="50" v-model="addForm.kilometers"></el-input>
            <span class="danwei">KM</span>
          </el-form-item>
          <el-form-item label="维修日期" prop="repairDate" class="jiage" >
            <el-date-picker
              v-model="addForm.repairDate"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              type="date"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="备注:" >
            <el-input placeholder="" maxlength="500" v-model="addForm.remark" size="mini"></el-input>
          </el-form-item>
          <br>
          <el-table :data="addForm.tireRepairDetailList" :key="tableKey" bordersize="mini" center border>
            <el-table-column type="index" label="序号" width="60"></el-table-column>
            <el-table-column label="操作" width="120" v-if="!isDetail">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="addGoodFn(scope.row)">追加</el-button>
                <el-button type="text" size="mini" @click="deleteTableRow(scope.$index)" :disabled="addForm.tireRepairDetailList.length <= 1">删除</el-button>
              </template>
            </el-table-column>
            <el-table-column label="新胎品牌">
              <template slot-scope="scope">
                <span v-if="isDetail">{{ scope.row.newTireBrand }}</span>
                <el-input v-else placeholder="" v-model="scope.row.newTireBrand" size="mini"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="新胎胎号">
              <template slot-scope="scope">
                <span v-if="isDetail">{{ scope.row.newTireSerial }}</span>
                <el-input v-else placeholder="" maxlength="8" v-model="scope.row.newTireSerial" size="mini">
                </el-input>
              </template>
            </el-table-column>
            <el-table-column label="旧胎品牌">
              <template slot-scope="scope">
                <span v-if="isDetail">{{ scope.row.oldTireBrand }}</span>
                <el-input v-else placeholder="" maxlength="8" v-model="scope.row.oldTireBrand" size="mini">
                </el-input>
              </template>
            </el-table-column>
            <el-table-column label="旧胎胎号">
              <template slot-scope="scope">
                <span v-if="isDetail">{{ scope.row.oldTireSerial }}</span>
                <el-input v-else placeholder="" maxlength="8" v-model="scope.row.oldTireSerial" size="mini">
                </el-input>
              </template>
            </el-table-column>
            <el-table-column label="领取数量(条)">
              <template slot-scope="scope">
                <span v-if="isDetail">{{ scope.row.receiveQuantity }}</span>
                <el-input v-else placeholder="" v-number-input.float="0" maxlength="8" v-model="scope.row.receiveQuantity" size="mini">
                </el-input>
              </template>
            </el-table-column>
            <el-table-column label="旧胎去向">
              <template slot-scope="scope">
                <span v-if="isDetail">{{ scope.row.oldTireDestination }}</span>
                <el-input v-else placeholder="" maxlength="8" v-model="scope.row.oldTireDestination" size="mini">
                </el-input>
              </template>
            </el-table-column>
            <el-table-column label="更换位置">
              <template slot-scope="scope">
                <span v-if="isDetail">{{ scope.row.replacePosition }}</span>
                <el-input v-else placeholder="" maxlength="8" v-model="scope.row.replacePosition" size="mini">
                </el-input>
              </template>
            </el-table-column>
          </el-table>
          <br>
          <el-form-item label="凭证:" class="remark" prop="remark" v-if="addFlag" >
             <uploadImgs :imgList.sync='imgList' :max=3 :disabled="isDetail" @remove="remove"></uploadImgs>
          </el-form-item>
          <br>
          <!-- <el-form-item label="申请备注:" class="remark" prop="remark" >
            <el-input  placeholder=""  maxlength="500" v-model="addForm.remark"></el-input>
          </el-form-item> -->
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addFlag = false">{{ isDetail ? '关 闭' : '取 消' }}</el-button>
        <el-button type="primary" @click="saveFn()" v-if="!isDetail">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 凭证 -->
    <el-dialog  title="凭证" :close-on-click-modal="false" :close-on-press-escape="false"   :visible.sync="pzFlag" width="660px" center>
      <div class="fujianBox">
         <div class="imgBox">
            <el-image
              v-for="(item,index) in pzList" :src="item.fileKeyUrl" :key="index" :preview-src-list="getSrcList(index,pzList)">
            </el-image>
          </div>
      </div>
    </el-dialog>
    <el-image-viewer v-if="dialogImg" :on-close="closeViewer" :url-list="lookimgList" />
    <!-- 导入 -->
    <importC v-if="importDialog" @DRsave="DRsave" @destroy="destroy"></importC>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { formatterRowEmpty, dateTimeFormat, dateFormat, toFixed, emptyFn } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import { costRecordList, saveOrUpdateCostWithAttachments, deleteCostRecord, getOilCostDetail, costRecordImport,
  getDictionaryDetailList } from '@/api/newTMS'
import { organizationTree, cDlists, cVIlists } from '@/api/vgs-driver2.0'
import uploadImgs from '@/views/newTMS/publicFiles/uploadImgs.vue'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import importC from '@/components/import.vue'
import driverVehicleForm from '@/views/newTMS/costExpense/driverVehicleForm.vue'
export default {
  components: {
    uploadImgs, ElImageViewer, importC, driverVehicleForm
  },
  data () {
    return {
      h: 500,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      formatterRowEmpty: formatterRowEmpty,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      useTime: [],
      total: 0,
      loading: false,
      isDisable: false,
      sum: {},
      rules: {
        teamCode: [
          { required: true, message: '请选择小队', trigger: 'blur' }
        ],
        driverId: [
          { required: true, message: '请选择司机', trigger: 'blur' }
        ],
        plateNumber: [
          { required: true, message: '请选择车辆', trigger: 'blur' }
        ],
        vehicleTeamCode: [
          { required: true, message: '车辆所属小队不能为空', trigger: 'blur' }
        ],
        driverPhone: [
          { required: true, message: '司机电话不能为空', trigger: 'blur' }
        ],
        maintenanceContent: [
          { required: true, message: '请输入维修项目', trigger: 'blur' }
        ],
        laborHours: [
          { required: true, message: '请输入维修工时', trigger: 'blur' }
        ],
        expenseAll: [
          { required: true, message: '请选择维修人员', trigger: 'submit' }
        ],
        kilometers: [
          { required: true, message: '请输入公里数', trigger: 'blur' }
        ],
        newTireBrand: [
          { required: true, message: '请输入新胎品牌', trigger: 'blur' }
        ],
        newTireModel: [
          { required: true, message: '请输入新胎型号', trigger: 'blur' }
        ],
        oldTireBrand: [
          { required: true, message: '请输入旧胎品牌', trigger: 'blur' }
        ],
        oldTireModel: [
          { required: true, message: '请输入旧胎型号', trigger: 'blur' }
        ],
        receiveQuantity: [
          { required: true, message: '请输入领取数量', trigger: 'blur' }
        ],
        oldTireDestination: [
          { required: true, message: '请输入旧胎去向', trigger: 'blur' }
        ],
        replacePosition: [
          { required: true, message: '请输入更换位置', trigger: 'blur' }
        ],
        repairDate: [
          { required: true, message: '请选择维修日期', trigger: 'blur' }
        ]
      },
      isAdd: false,
      isDetail: false,
      addFlag: false,
      addForm: { deleteAttachmentIds: [], expenseAll: [] },
      imgList: [],
      gysList: [], // 采购商
      XDList: [],
      sijiList: [],
      carList: [],
      pzList: [],
      pzFlag: false,
      dialogImg: false,
      lookimgList: [],
      importDialog: false,
      btnFlg: [],
      btnIdArr: ['01N02K0100', '01N02K0200', '01N02K0300', '01N02K0400', '01N02K0500', '01N02K0600', '01N02K0700', '01N02K0800'],
      busineType: 15,
      tableKey: 0
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr)
    this.searchFn()
    getDictionaryDetailList({ dictionaryType: 'repair_worker' }).then(res => { this.gysList = res })
    cDlists({ driverClassify: 2, tenantId: localStorage.getItem('tenantCode') }).then(res => { this.sijiList = res })
    cVIlists({ vhcClassify: 2, trailerFlag: 0, tenantId: localStorage.getItem('tenantCode') }).then(res => {
      this.carList = res
    })
    organizationTree({ flag: 1 }).then((res) => {
      if (res[0].orgType == 1) {
        this.XDList = res[0].children
      } else {
        this.XDList = res
      }
    })
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 203) + 'px'
  },
  methods: {
    // 导入
    importFn () {
      this.importDialog = true
    },
    // 导入模板下载
    modelDown () {
      var tempwindow = window.open('_blank') // 先打开页面
      tempwindow.location = 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/tms/excel/轮胎维修导入模板.xlsx'// 后更改页面地址
    },
    DRsave (formData) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      // formData.append('params', JSON.stringify({ id: '' }))
      formData.append('businessType', this.busineType)
      costRecordImport(formData).then(res => {
        loading.close()
        this.importDialog = false
        this.msg = this.$message({
          showClose: true,
          message: res.message,
          duration: 3000,
          type: 'success',
          onClose () {

          }
        })
        this.getList(this.searchFrom)
      }).catch(err => {
        if (err.code == -1) {
          this.$message({
            type: 'warning',
            message: err.data ? err.data : err.message,
            onClose () {
              loading.close()
            }
          })
          this.isDisable = false
        } else if (err.code == 1) {
          this.isDisable = false
          this.$confirm('存在异常信息，是否确认导出异常信息?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const loading = this.$loading({
              lock: true,
              text: '正在导出异常信息...'
            })
            let form = { businessType: this.busineType }
            exportExcel(
              this.global.tmsPlus +
                    '/costRecord/exportError',
              form,
              '异常信息表'
            )
            setTimeout(() => {
              this.$message({
                type: 'success',
                message: err.data ? err.data : err.message
              })
              loading.close()
              this.daoRuMark = false
              this.importDialog = false
              this.getList(this.searchFrom)
            }, 3000)
          }).catch(() => {
            this.daoRuMark = false
            this.$message({
              type: 'warning',
              message: '已取消异常信息导出，' + err.data ? err.data : err.message,
              onClose () {
                loading.close()
              }
            })
          })
        } else {
          loading.close()
        }
      })
    },
    destroy () {
      this.importDialog = false
    },
    // 选择数据
    selectGoods (selection) {
    },
    // 凭证
    pingzhengFn (row) {
      getOilCostDetail({ costId: row.id }).then(res => {
        if (res.attachments.length == 0) {
          this.$alert('暂无可查看的凭证', '系统提示')
        } else {
          this.lookimgList = []
          res.attachments.forEach((item, index) => {
            this.$set(this.lookimgList, index, item.fileKeyUrl)
          })

          this.dialogImg = true
        }
      })
    },
    closeViewer () {
      this.dialogImg = false
    },
    // 点击凭证放大
    getSrcList (index, arr) {
      let imgArr = arr.slice(index).concat(arr.slice(0, index))
      let urls = []
      imgArr.forEach(item => {
        urls.push(item.fileKeyUrl)
      })
      return urls
    },
    sijiChange (e) {
      if (e) {
        let json = this.sijiList.filter(item => item.id == e)
        this.$set(this.addForm, 'driverName', json[0].name)
        this.$set(this.addForm, 'driverPhone', json[0].mobile)
        this.$set(this.addForm, 'idNumber', json[0].identityNo)
        this.$set(this.addForm, 'rootTissueId', json[0].companyOrgId)
        this.$set(this.addForm, 'rootTissueCode', json[0].companyOrgCode)
        this.$set(this.addForm, 'rootTissueName', json[0].companyOrgName)
        this.$set(this.addForm, 'teamOrgId', json[0].teamOrgId)
        this.$set(this.addForm, 'teamOrgName', json[0].teamOrgName)
        this.$set(this.addForm, 'teamCode', json[0].teamOrgCode)
        this.$set(this.addForm, 'teamName', json[0].teamOrgName)
        this.$set(this.addForm, 'teamId', json[0].teamOrgId)
      }
    },
    carChange (e) {
      if (e) {
        let json = this.carList.filter(item => item.vhcNo == e)
        this.$set(this.addForm, 'vehicleId', json[0].id)
        this.$set(this.addForm, 'licensePlateColorName', json[0].noColourName)
        this.$set(this.addForm, 'vehicleTypeName', json[0].vhcTypeName)
        this.$set(this.addForm, 'trailerPlate', json[0].trailerNo)
        this.$set(this.addForm, 'vehicleTeamId', json[0].teamOrgId)
        this.$set(this.addForm, 'vehicleTeamCode', json[0].teamOrgCode)
        this.$set(this.addForm, 'vehicleTeamName', json[0].teamOrgName)
      }
    },
    xiaoduiChange (e) {
      if (e) {
        let json = this.XDList.filter(item => item.code == e)
        this.$set(this.addForm, 'teamName', json[0].name)
        this.$set(this.addForm, 'teamId', json[0].id)
        cDlists({ driverClassify: 2, teamOrgId: json[0].id }).then(res => {
          this.sijiList = res
        })
        cVIlists({ vhcClassify: 2, trailerFlag: 0, teamOrgId: json[0].id }).then(res => {
          this.loading = false
          this.carList = res
        })
        this.$set(this.addForm, 'driverId', null)
        this.$set(this.addForm, 'driverName', null)
        this.$set(this.addForm, 'driverPhone', null)
        this.$set(this.addForm, 'idNumber', null)
        this.$set(this.addForm, 'rootTissueId', null)
        this.$set(this.addForm, 'rootTissueCode', null)
        this.$set(this.addForm, 'rootTissueName', null)
        this.$set(this.addForm, 'vehicleId', null)
        this.$set(this.addForm, 'plateNumber', null)
        this.$set(this.addForm, 'licensePlateColorName', null)
        this.$set(this.addForm, 'vehicleTypeName', null)
      }
    },
    // 添加
    addFn () {
      this.isDetail = false
      this.isAdd = true
      this.addFlag = true
      this.imgList = []
      // 初始化一行空数据
      this.addForm.tireRepairDetailList = [{
        newTireBrand: '',
        newTireSerial: '',
        oldTireBrand: '',
        oldTireSerial: '',
        receiveQuantity: '',
        oldTireDestination: '',
        replacePosition: ''
      }]
      this.totalAmount = 0
      this.totalRepairQuantity = 0
      this.addForm.deleteAttachmentIds = []
    },
    // 详情
    detailFn (row) {
      this.loadRepairDetail(row, true)
    },
    // 修改
    editFn (row) {
      this.loadRepairDetail(row, false)
    },
    loadRepairDetail (row, isDetail) {
      this.addForm = { ...row }
      this.addForm.deleteAttachmentIds = []
      if (row.repairDate) {
        this.$set(this.addForm, 'repairDate', this.timeStamp(row.repairDate))
      }
      this.$set(this.addForm, 'expenseAll', row.repairWorkers.split(','))
      getOilCostDetail({ costId: row.id }).then(res => {
        this.isDetail = isDetail
        this.isAdd = false
        this.addFlag = true
        this.addForm.tireRepairDetailList = res.tireRepairDetails
        // 加载凭证
        this.addForm.deleteAttachmentIds = []
        this.imgList = []
        res.attachments.forEach(item => {
          this.imgList.push({ status: 'ready', url: item.fileKeyUrl, id: item.id })
        })
      })
    },
    saveFn () {
      const repairList = this.addForm.tireRepairDetailList
      if (!repairList || repairList.length === 0) {
        this.$alert('请至少添加一条维修记录', '系统提示')
        return
      }
      for (let i = 0; i < repairList.length; i++) {
        const item = repairList[i]
        if (!item.newTireBrand || item.newTireBrand.trim() === '') {
          this.$alert(`第${i + 1}行的"新胎品牌"不能为空`, '系统提示')
          return
        }
        if (!item.newTireSerial && item.newTireSerial !== 0) {
          this.$alert(`第${i + 1}行的"新胎胎号"不能为空`, '系统提示')
          return
        }
        if (!item.oldTireBrand && item.oldTireBrand !== 0) {
          this.$alert(`第${i + 1}行的"旧胎品牌"不能为空`, '系统提示')
          return
        }
        if (!item.oldTireSerial && item.oldTireSerial !== 0) {
          this.$alert(`第${i + 1}行的"旧胎胎号"不能为空`, '系统提示')
          return
        }
        if (!item.receiveQuantity && item.receiveQuantity !== 0) {
          this.$alert(`第${i + 1}行的"领取数量"不能为空`, '系统提示')
          return
        }
        if (!item.oldTireDestination && item.oldTireDestination !== 0) {
          this.$alert(`第${i + 1}行的"旧胎去向"不能为空`, '系统提示')
          return
        }
        if (!item.replacePosition && item.replacePosition !== 0) {
          this.$alert(`第${i + 1}行的"更换位置"不能为空`, '系统提示')
          return
        }
      }
      // if (this.imgList.length == 0) {
      //   this.$alert('请上传凭证', '系统提示')
      //   return
      // }
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          let imgfile = new FormData()
          this.imgList.forEach(item => {
            if (!item.id) {
              imgfile.append('files', item.raw)
            }
          })
          if (this.isAdd) {
            this.addForm.source = 2
            this.addForm.businessType = this.busineType
          }
          imgfile.set('params', JSON.stringify(this.addForm))
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          saveOrUpdateCostWithAttachments(imgfile).then(res => {
            loading.close()
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.addFlag = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        } else {
          return false
        }
      })
    },
    // 删除文件
    remove (file) {
      if (file.id) {
        this.addForm.deleteAttachmentIds.push(file.id)
      }
    },
    // 供应商修改
    gysChange (e) {
      if (e) {
        this.$set(this.addForm, 'repairWorkers', this.addForm.expenseAll.toString())
      }
    },
    // 删除
    delFn () {
      let selectData = this.$refs.table.selection
      this.rowDataList = selectData
      if (selectData.length != 1) {
        this.$alert('请选择一条要操作的数据', '系统提示')
        return
      }
      if (selectData[0].source == 1) {
        this.$alert('司机上报不可删除', '系统提示')
        return
      }
      this.$confirm('是否执行删除操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        deleteCostRecord({
          ids: [selectData[0].id]
        }).then(res => {
          loading.close()
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 导出
    exportFn () {
      this.searchFrom.businessType = this.busineType
      let form = { ...this.searchFrom }
      delete form.pageNo
      delete form.pageSize
      exportExcel(
        this.global.tmsPlus + '/costRecord/export',
        form,
        '轮胎维修列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList () {
      this.loading = true
      this.searchFrom.businessType = this.busineType
      costRecordList(this.searchFrom).then(res => {
        this.tableList = res.list
        this.total = res.total
        this.sum = res.map
        this.loading = false
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
      this.searchFn()
    },
    closeDialog () {
      this.addForm = { tireRepairDetailList: [], deleteAttachmentIds: [] }
      this.isDetail = false
      this.currentRowIndex = -1
      this.tableKey = 0 // 重置 key
    },
    // 添加表格行（追加到当前行后面，默认填充当前行的内容）
    addGoodFn (row) {
    // 深拷贝当前行
      let newRow = JSON.parse(JSON.stringify(row))
      delete newRow.id
      // 添加新行
      this.addForm.tireRepairDetailList.push(newRow)
      // 更新 key 强制表格重新渲染
      this.tableKey++
      console.log('添加后行数：', this.addForm.tireRepairDetailList.length)
    },
    // 删除表格行
    deleteTableRow (index) {
      if (this.addForm.tireRepairDetailList.length > 1) {
        this.addForm.tireRepairDetailList.splice(index, 1)
        this.addForm.tireRepairDetailList = [...this.addForm.tireRepairDetailList]
        this.tableKey++
      }
    },
    // 日期格式化
    timeStamp (dateStr) {
      if (!dateStr) return ''
      let date = new Date(dateStr)
      let Y = date.getFullYear()
      let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1)
      let D = date.getDate() < 10 ? ('0' + date.getDate()) : date.getDate()
      return Y + '-' + M + '-' + D
    }
  },
  watch: {
    addForm: {
      handler (newName, oldName) {
        if (this.addForm.quantity && this.addForm.amount) {
          this.$set(this.addForm, 'unitPrice', toFixed(this.addForm.amount / this.addForm.quantity, 2))
        }
      },
      immediate: true,
      deep: true
    }
  }

}
</script>

<style scoped lang='less'>
.searchBtnBox{
  margin: 10px 0;
}
.inpBox .el-date-editor{
  width:430px!important;
}
/deep/.el-form{
  width: 100%;
}
.jiaoyan /deep/.el-input__inner{
      width: 180px;
}
.imgBox{
  margin:0;
}

.inpBox .dzBox  /deep/.el-input__inner {
    width: 170px;
}
.imgBox{
  /deep/.el-image{
    width: 180px;
    height: 130px;
    margin-right: 20px;
  }
}
.remark  /deep/.el-input .el-input__inner {
    width: 480px;
    height: 80px;
}
.tongjiBox{
   /deep/.el-form-item--mini .el-form-item__content,  /deep/.el-form-item--mini .el-form-item__label{
        line-height: 20px;
  }
}
.width2  /deep/.el-input .el-input__inner {
    width: 480px;
}
.formItemBox{
  /deep/.el-form-item{
    width: 24%;
  }
}
/deep/.el-input.is-disabled .el-input__inner {
  color: #333;
}
/* 修复表格内输入框被边框遮挡的问题 */
.jiaoyan {
  /deep/ .el-table {
    /* 保持表格原有 overflow 设置，不覆盖全局 */

    td {
      /* 只针对包含输入框的单元格，通过判断是否有 input 元素 */
      .cell {
        /* 保持原有的 overflow 设置，让 tooltip 正常工作 */
        padding: 5px 5px;

        /* 只让输入框正常显示，不改变父级 overflow */
        .el-input {
          display: block;
          width: 100%;

          .el-input__inner {
            border: 1px solid #DCDFE6;
            height: 26px;
            line-height: 26px;
            padding: 0 8px;
            width: 100%;
            /* 确保输入框在单元格内可见，不超出边框 */
            box-sizing: border-box;
          }
        }
      }
    }

    /* 修复表格边框样式，让输入框不超出边界 */
    border: 1px solid #EBEEF5;
    border-radius: 4px;

    th, td {
      border-right: 1px solid #EBEEF5;
      border-bottom: 1px solid #EBEEF5;
    }
  }
}
</style>
